<!--切换节点-->
<template>
  <div class="switch-container">
    <headerIndex/>
    <div class="switch-content" :style="'min-height:'+min_height+'px;'">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+pName }">
          {{ pName }}
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="types==2"><a @click="back(2)">{{ childNode.name }}企业综合服务平台</a></el-breadcrumb-item>
        <el-breadcrumb-item>切换节点</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="info-menu">
        <p class="SourceHanSansCN title">
          <span v-if="types==2">{{ childNode.name }}企业数字化服务云平台</span>
          <span v-else>{{ childNode.name }}企业数字化服务云平台</span>
          <el-button round class="more-things" @click="moreInfo">更多信息</el-button>
        </p>
        <p class="tips SourceHanSansCN">为中小微、民营企业提供知识产权、科技服务、上云服务、融资服务、政策培育等一站式综合服务，是政府为企业提供精准服务的主要抓手，是企业高质量发展的主要帮手。</p>
        <p class="describe SourceHanSansCN">
          <span class="default-span">服务商</span><span class="large-span">{{ statistics.fuWuShangNum }}</span>
          <span class="default-span">惠企政策</span><span class="large-span">{{ statistics.policyNum }}</span>
          <span class="default-span">服务产品</span><span class="large-span">{{ statistics.goodsNum }}</span>
        </p>
      </div>
      <div class="switch-list">
        <p class="small-title SourceHanSansCN">切换节点</p>
        <el-radio-group v-model="childNode.cityCode" @change="changeCityNode">
          <el-radio-button v-for="city of childNodes" :label="city.cityCode">{{ city.name  }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <Hang/>
    <home_footer/>
    <el-dialog :visible.sync="dialogVisible" class="switch-dialog" width="35%">
      <span slot="title" class="SourceHanSansCN title">关于平台</span>
      <div class="dialog-info">
        <p class="SourceHanSansCN title" v-if="types==2">{{ childNode.name }}企业数字化服务云平台</p>
        <p class="SourceHanSansCN title" v-else>{{ childNode.name }}企业数字化服务云平台</p>
        <p class="tips SourceHanSansCN"><span class="gary-tips">简介：</span>{{ ptAboutPlatform.content }}</p>
        <p class="describe SourceHanSansCN">
          <span class="default-span">服务商</span><span class="large-span">{{ statistics.fuWuShangNum }}</span>
          <span class="default-span">惠企政策</span><span class="large-span">{{ statistics.policyNum }}</span>
          <span class="default-span">服务产品</span><span class="large-span">{{ statistics.goodsNum }}</span>
        </p>
        <p style="padding-top: 30px;">
          <span class="gray-label SourceHanSansCN">指导单位：</span>
          <span class="SourceHanSansCN default-label">{{ ptAboutPlatform.guideUnit }}</span>
        </p>
        <p>
          <span class="gray-label SourceHanSansCN">运营主体：</span>
          <span class="SourceHanSansCN default-label">{{ ptAboutPlatform.operator }}</span>
        </p>
        <p>
          <span class="gray-label">营业执照：</span>
          <el-link type="primary" :underline="false" @click="seePdf(ptAboutPlatform.businessLicense)"
                   v-if="ptAboutPlatform.businessLicense">查看
          </el-link>
          <el-link type="primary" :underline="false" v-else :disabled="true">查看</el-link>
        </p>
        <p>
          <span class="gray-label">资质荣誉：</span>
          <el-link type="primary" :underline="false" @click="seePdf(honors)"
                   v-if="honors">查看
          </el-link>
          <el-link type="primary" :underline="false" v-else :disabled="true">查看</el-link>
        </p>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogImage" title="图片预览" width="550px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {servicesNumber, aboutPlatform} from '@/api/cloudServiceApi'
import $store from "@/store";

export default {
  name: "switchNode",
  components: {home_footer, headerIndex, Hang},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 318,
      dialogVisible: false,
      cityArray: [],
      nodes: 2,
      pName: '',
      statistics: {serviceProvider: 256, policy: 125, service: 458},
      cid: 0,
      ptAboutPlatform: {},
      dialogImage: false,
      dialogImageUrl: '',
      types:1,
      honors:'',
    }
  },
  computed: {
    childNode() {
      return $store.state.childNode
    },
    childNodes(){
      return $store.state.childNodes
    }
  },
  methods: {
    /*返回上一级页面*/
    back(type) {
      if (type == 1)
        this.$router.replace({path: '/serviceNet/localServe'})
      else
        this.$router.back(-1);
    },
    /*切换节点*/
    changeCityNode(value, $event) {
      for (let city of this.childNodes) {
        if (value == city.cityCode) {
          $store.commit('SET_CHILD_NODE', JSON.stringify(city));
          this.$router.push({
            path: '/cloudPlatform/platform',
            query: {
              city: city.cityCode,
              cityName: city.name,
              cityCode: city.cityCode,
              parentCityCode: city.parentCityCode,
              pName: city.name + '企业数字化服务云平台',
              parName:this.pName
            }
          })
        }
      }
    },
    /*更多信息*/
    moreInfo() {
      aboutPlatform({
        cityCode: this.childNode.cityCode,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.ptAboutPlatform = res.content.ptAboutPlatform;
          if (this.ptAboutPlatform){
            if (res.content.ptAboutPlatform.sonList.length>0){
              this.honors=res.content.ptAboutPlatform.sonList;
            }
            this.dialogVisible = true;
          }else{
            this.$message.error('暂无平台相关介绍！');
          }
        }
      })
    },
    /*服务商数量/惠企政策数量/服务产品数量*/
    getServicesNumber() {
      servicesNumber({
        cityCode: this.childNode.cityCode,
        level: 1,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        this.statistics = res.content;
      })
    },
    /*证书预览*/
    seePdf(url) {
      this.dialogImageUrl = url;
      this.dialogImage = true;
    }
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    this.types=this.$route.query.type;
  },
  mounted() {
    this.getServicesNumber();
  }
}
</script>
<style scoped>
.switch-container >>> .switch-content .switch-list .el-radio-button__inner:hover {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  box-shadow: -1px 0 0 0 #fe273b;
}

.switch-container >>> .switch-content .switch-list .el-radio-button__inner {
  border-left: 1px;
  color: #333333;
  font-size: 16px;
  margin-right: 20px;
  border: 1px solid #DDDDDD;
  padding: 15px 38px;
  border-radius: 6px;
  min-width: 130px;
}

.switch-container >>> .switch-content .switch-list .el-radio-button {
  margin-bottom: 20px;
}

.switch-container >>> .switch-content .switch-list .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  box-shadow: -1px 0 0 0 #fe273b;
}

.switch-dialog >>> .title {
  line-height: 24px;
  font-size: 16px;
  color: #303133;
}

.switch-dialog >>> .el-dialog__header {
  padding: 10px 20px 10px;
  border-bottom: 1px solid #EEEEEE;
}

.switch-dialog >>> .el-link.el-link--primary {
  color: #1637FF;
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.switch-container {
  .switch-content {
    padding: 20px 18%;
    min-width: 76rem;
    background: #F5F5F5;
    .info-menu {
      background: #F5F5F5;
      padding-top: 50px;

      .title {
        font-size: 36px;
        margin-block-start: 0;
        margin-block-end: 0;
        cursor: context-menu;

        .more-things {
          float: right;
          padding: 14px 23px;
          color: #FE273B;
          border: 1px solid #FE273B;
          background: #F5F5F5;
          min-width: 120px;
        }
      }

      .tips {
        width: 615px;
        font-size: 14px;
        color: #333333;
        cursor: context-menu;
      }

      .describe {
        margin-block-start: 0;
        margin-block-end: 0;
        padding-top: 20px;

        .default-span {
          cursor: context-menu;
          font-size: 16px;
          color: #666666;
        }

        .large-span {
          cursor: context-menu;
          color: #333333;
          font-size: 22px;
          padding-right: 70px;
          padding-left: 5px;
        }
      }
    }

    .switch-list {
      background: #ffffff;
      padding: 20px;
      min-height: 300px;
      margin-top: 40px;

      .small-title {
        margin-block-start: 0;
        margin-block-end: 0;
        font-size: 20px;
        padding-bottom: 30px;
        cursor: context-menu;
      }
    }
  }
}

.dialog-info {
  background: #ffffff;

  .title {
    font-size: 20px;
    margin-block-start: 0;
    margin-block-end: 0;
    cursor: context-menu;
    width: fit-content;
  }

  .tips {
    font-size: 14px;
    color: #666666;
    cursor: context-menu;

    .gary-tips {
      color: #999999;
    }
  }

  .describe {
    margin-block-start: 0;
    margin-block-end: 0;
    padding-top: 20px;
    width: fit-content;

    .default-span {
      cursor: context-menu;
      font-size: 16px;
      color: #666666;
    }

    .large-span {
      cursor: context-menu;
      color: #333333;
      font-size: 22px;
      padding-right: 70px;
      padding-left: 5px;
    }
  }

  .gray-label {
    color: #999999;
    font-size: 14px;
    padding-right: 90px;
  }

  .default-label {
    font-size: 14px;
    color: #333333;
  }
}
</style>